module.exports = __webpack_public_path__ + "resources/img/img_hi_psm2_m.424288c3325ae0086983b431eb03f2d6.png";